/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AlterarDataValidadeAliases {
  DATE_FIELD_0 = 'date-field-0',
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_NOTIFICATION = 'field-notification',
  FORM_ALTERAR = 'form-alterar',
  MAPPER_0 = 'mapper-0',
  PANEL_ALTERAR_DATA_VALIDADE = 'panel-alterar-data-validade',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { AlterarDataValidadeAliases };
